import React, { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Typography, Grid, Box, Card } from "@mui/material";
import Swal from "sweetalert2";
import { UserProfileContext } from "../UserProfile";
import { ProviderServices } from "../CrudServices";
import Loading from "../../../components/Loader/Loading";
import RegistrationFeeInfo from "./RegistrationFeeInfo";

export default function PaymentDetails({ providerId }) {
  const { otrDetail, paymentDetailsData, setPaymentDetailsData, fetchUserDetails, providerPersonalDetails, businessDetailsData } = useContext(UserProfileContext);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [registrationFeeData, setRegistrationFeeData] = useState({
    id: 0,
    providerId: otrDetail?.id ,
    txnId: "",
    paymentMethod: "", //'CASH', 'CARD', 'WALLET', 'ONLINE', 'NEFT', 'UPI'
    paymentType: "REGISTRATION_FEE",
    baseAmount: "",
    discountPercent: 0,
    discount: 0,
    taxableAmount: "",
    igst: 0,
    cgst: 0,
    sgst: 0,
    gstAmount: "",
    totalAmount: "",
    comment: "",
    txnDate: "",
    status: "PENDING", //'PENDING', 'COMPLETED', 'FAILED', 'REFUND'
  });

  const paymentDetailFormMethod = useForm({
    mode: "onChange",
    defaultValues: {
      ...registrationFeeData,
      providerId: otrDetail?.id,
      taxSlab: registrationFeeData?.igst == "0" ? "gst" : "igst",
    },
  });

  useEffect(() => {
    setValue("providerId", otrDetail?.id)
  }, [otrDetail]);

  const {
    control,
    watch,
    setValue,
    handleSubmit,
    formState: { errors, isDirty },
    setError,
    clearErrors,
    reset,
  } = paymentDetailFormMethod;

  const onSubmitFormData = async (data) => {
    console.log("Payment Detail Data:", data);
    const { taxSlab, ...restData } = data;

    try {
      setIsSubmitted(true);
      const response = await ProviderServices.addUpdateproviderPaymentDetail({
        ...restData,
        status: "COMPLETED",
      });
      //   const businessDetailUpdateResponse = await ProviderServices.updateUserBusinessDetail({providerId:otrDetail.id,...data});
      console.log("Payment Detail AddUpdate Response:", response);
      if (response?.success == "1") {
        fetchUserDetails();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message,
          confirmButtonText: "OK",
        });
        setIsSubmitted(false);
      }
      // if(businessDetailUpdateResponse?.success=='0')
      else {
        Swal.fire(response.message, "", "error");
        //   Swal.fire({
        //       icon: 'error',
        //       // title: 'Unauthorized',
        //       text: businessDetailUpdateResponse.message,
        //       confirmButtonText: 'OK'
        //   });
        setIsSubmitted(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        // title: 'Unauthorized',
        text: error.message,
        confirmButtonText: "OK",
      });
    } finally {
      setIsSubmitted(false);
    }
  };

  useEffect(() => {
    if (paymentDetailsData && paymentDetailsData.length > 0) {
      const registrationFee = paymentDetailsData.find(
        (data) => data.paymentType === "REGISTRATION_FEE"
      );
      if (registrationFee) {
        const requiredData = {
          id: registrationFee.id,
          providerId: registrationFee.providerId,
          txnId: registrationFee.txnId,
          paymentMethod: registrationFee.paymentMethod,
          paymentType: registrationFee.paymentType,
          baseAmount: registrationFee.baseAmount,
          discountPercent: registrationFee.discountPercent,
          discount: registrationFee.discount,
          taxableAmount: registrationFee.taxableAmount,
          igst: registrationFee.igst,
          cgst: registrationFee.cgst,
          sgst: registrationFee.sgst,
          gstAmount: registrationFee.gstAmount,
          totalAmount: registrationFee.totalAmount,
          comment: registrationFee.comment,
          txnDate: registrationFee.txnDate,
          status: registrationFee.status,
        };
        setRegistrationFeeData(requiredData);
        console.log(
          "resetting payment form details"
        )
        // reset(
        //   {
        //     ...requiredData,
        //     taxSlab: requiredData?.igst == "0" ? "gst" : "igst",
        //   },
        //   { keepDirty: false, keepValues: true }
        // );
        paymentDetailFormMethod.reset({
          ...requiredData,
          // providerId: otrDetail && otrDetail.id > 0 ? otrDetail.id : 0,
          taxSlab: providerPersonalDetails?.serviceAddress?.state == "Uttar Pradesh" ? "gst" : "igst",
        });
        console.log("form values:",requiredData)
      }
    }
    // paymentDetailFormMethod.reset({
    //   ...registrationFeeData,
    //   providerId: otrDetail && otrDetail.id > 0 ? otrDetail.id : 0,
    //   taxSlab: providerPersonalDetails?.serviceAddress?.state == "Uttar Pradesh" ? "gst" : "igst",
    // });
  }, [paymentDetailsData, reset]);
  return (
    <FormProvider {...paymentDetailFormMethod}>
      {isSubmitted && <Loading />}
      <Grid container spacing={1} component={"form"}>
        {/* =======================Registration Fee Info section================== */}
        <RegistrationFeeInfo registrationFee={registrationFeeData} />
        <Box sx={{ textAlign: "center", width: "100%", mt: 1 }}>
          <Button
            disabled={!isDirty || isSubmitted}
            variant="contained"
            onClick={handleSubmit(onSubmitFormData)}
            size="small"
          >
            {registrationFeeData?.id ? "Update" : "Save"}
          </Button>
        </Box>
      </Grid>
    </FormProvider>
  );
}
